export default __webpack_public_path__ + "ce0589167fc12126cf8850195698d6e6.png";